import React from "react";
import SlickImageGallery from "../common/SlickImageGallery";
// # components
import Tabs from "../common/tabs/Tabs";
import UK1 from "../../assets/images/media/uk/1.jpg";
import UK2 from "../../assets/images/media/uk/2.jpg";
import UK3 from "../../assets/images/media/uk/3.jpg";
import UK4 from "../../assets/images/media/uk/4.jpg";

function Media() {
  const UKData = [
    {
      content: UK1,
      key: "UK1",
    },
    {
      content: UK2,
      key: "UK2",
    },
    {
      content: UK3,
      key: "UK3",
    },
    {
      content: UK4,
      key: "UK4",
    },
  ];

  return (
    <section className="mt-[60px] lg:mt-[120px] mx-[20px] lg:mx-[40px] pb-0 lg:pb-[20px] xl:pb-[80px]">
      <div className="text-center pb-[20px]">
        <h2 className="text-24px font-bold mb-[18px]">METATOR MEDIA</h2>
      </div>

      <Tabs
        className="mx-auto"
        centered
        contentClassName="text-center"
        defaultCurrent="1"
        items={[
          {
            label: "UK Property Show 2022",
            key: "1",
            // make sure all your images have same resolution. (16:9 preferred)
            content: (
              <>
                <p className="mb-3">Ranked #1 in the UK Property Show 2022.</p>
                <SlickImageGallery
                  images={UKData}
                  className="w-full lg:w-3/4 1xl:w-[1096px] mx-auto"
                />
              </>
            ),
          },
          {
            label: "Istanbul Blockchain Week 2022",
            key: "2",
            content: <div>Coming soon</div>,
          },
        ]}
      />
    </section>
  );
}

export default Media;
